exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-on .cell[data-v-2d6f553c]{overflow:visible;overflow-x:visible;overflow-y:visible}\n", ""]);

// exports
